import { Spin } from 'antd'
import React, { createContext, useContext, useEffect, useState } from 'react'
import { Outlet, useNavigate } from 'react-router'
import { post } from '../../Common/api'
import { onlyUnique } from '../../Common/Common'
import dayjs from 'dayjs'
import { t } from 'i18next'
import PublicContext from '../PublicContext'

const SpecialistContext = createContext()
export default SpecialistContext

export const SpecialistContextProvider = () => {
  const { box, setData } = useContext(PublicContext)
  const [loading, setLoading] = useState(false)
  const [reasons, setReasons] = useState()
  const [reason, setReason] = useState()
  const [allSpecialists, setAllSpecialists] = useState()
  const [specialists, setSpecialists] = useState()
  const [specialist, setSpecialist] = useState(undefined)
  const [allMonthAvailabilities, setAllMonthAvailabilities] = useState()
  const [monthAvailabilities, setMonthAvailabilities] = useState()
  const [loadMonthAvailabilities, setLoadMonthAvailabilities] = useState(false)
  const [date, setDate] = useState(dayjs())
  const [day, setDay] = useState(dayjs())
  const [slots, setSlots] = useState()
  const navigate = useNavigate()

  const getMonthAvailabilities = (monthDate, calendars = null) => {
    calendars = calendars || allSpecialists
    setLoadMonthAvailabilities(true)
    post({
      url: 'calendoc/month_availabilities',
      params: { date: monthDate.startOf('month').format('YYYY-MM-DD'), specialist_ids: calendars?.map(e => e.id) },
      onSuccess: (res) => {
        setAllMonthAvailabilities({ ...res.availabilities, date: monthDate.startOf('month') })
        setLoadMonthAvailabilities(false)
      }
    })
  }

  const getDayAvailabilities = (monthDate, reasonId, specialists, box) => {
    post({
      url: 'calendoc/day_availabilities',
      params: { date: monthDate.format('YYYY-MM-DD'), reason_id: reasonId, specialist_ids: specialists.map((v) => (v.id)), box_id: box.id },
      onSuccess: (res) => {
        if (res.slots.length > 0) {
          setSlots(res.slots.map((v) => ({ ...v, time: dayjs(v.time) })).sort((a, b) => a.time - b.time))
        } else {
          setSlots(res.slots)
        }
      }
    })
  }

  const defineCalendar = (specialists, allMonthAvailabilities) => {
    if (specialists.length === 0) {
      setMonthAvailabilities([])
      setSpecialist(undefined)
    } else if (specialists.length === 1) {
      setMonthAvailabilities(allMonthAvailabilities[specialists[0].id])
      setSpecialist(specialists[0])
    } else {
      const colors = {}
      const result = []
      specialists.forEach(specialist => {
        allMonthAvailabilities[specialist.id].forEach(availability => {
          if (colors[availability.day] === undefined) {
            colors[availability.day] = [availability.color]
          } else {
            colors[availability.day].push(availability.color)
          }
        })
      })
      Object.keys(colors).forEach(day => {
        const color = colors[day].filter(onlyUnique).length > 1 ? '#01DF01' : colors[day].filter(onlyUnique)[0]
        result.push({ color, day })
      })
      setMonthAvailabilities(result)
      setSpecialist(undefined)
    }
    setDate(allMonthAvailabilities.date)
  }

  const saveSlot = (slot, calendarId, reasonId) => {
    const values = { specialist: true, slotTime: slot, calendarId, boxId: box.id, reasonId }
    setData(values)
    navigate(`/box/${box.id}/specialist_slot_create`)
  }

  const getSpecialistInfo = () => {
    setLoading(true)
    post({
      url: 'calendoc/specialist_info',
      params: { box_id: box.id },
      onSuccess: (res) => {
        setAllSpecialists(res.specialists)
        setReasons(res.reasons)
        getMonthAvailabilities(date, res.specialists)
        if (res.reasons.length > 0) {
          setReason(res.reasons[0])
          getDayAvailabilities(date, res.reasons[0].id, res.specialists, box)
        }
        setLoading(false)
      },
      onFailure: () => {
        setLoading(false)
      }
    })
  }

  useEffect(() => {
    if (box) {
      getSpecialistInfo()
    }
  }, [box])

  useEffect(() => {
    if (specialist) {
      defineCalendar([specialist], allMonthAvailabilities)
    } else if (allMonthAvailabilities && specialists) {
      defineCalendar(specialists, allMonthAvailabilities)
    }
  }, [specialists, allMonthAvailabilities])

  useEffect(() => {
    if (allSpecialists) {
      const filteredSpecialists = allSpecialists.filter(e => e.reasons.map(e => e.id).includes(reason.id))
      setSpecialists(filteredSpecialists)
      if (reason) {
        if (specialist === undefined) {
          getDayAvailabilities(day, reason.id, filteredSpecialists, box)
        } else {
          getDayAvailabilities(day, reason.id, [specialist], box)
        }
      }
    }
  }, [specialist, day, reason, allSpecialists, box])

  const values = {
    getMonthAvailabilities,
    loadMonthAvailabilities,
    getDayAvailabilities,
    defineCalendar,
    reasons,
    reason,
    setReason,
    allSpecialists,
    specialists,
    specialist,
    setSpecialist,
    allMonthAvailabilities,
    monthAvailabilities,
    date,
    day,
    setDay,
    slots,
    box,
    saveSlot,
    setDate
  }

  return <SpecialistContext.Provider value={values}>
    <Spin spinning={loading} tip={t('Public.Specialist.loading')}> <Outlet /> </Spin>
  </SpecialistContext.Provider>
}
